import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Flex } from "@mantine/core";
import { DAYS } from "../../datasets/days_available";
import { useDeviceType } from "../../hooks/useDeviceType";
import { titleCase } from "../../utils/String.utils";
export const DayChipGroup = ({ value, abbreviate = false, size = "lg", onChipChange }) => {
    const { isUpToMediumScreen } = useDeviceType();
    return (_jsx(Chip.Group, { multiple: true, value: value?.filter((v) => v !== null) ?? [], onChange: (v) => onChipChange(v), children: _jsx(Flex, { justify: "space-between", children: DAYS.map((d) => {
                return (_jsx(Chip, { value: d, size: size, styles: {
                        iconWrapper: {
                            display: "none"
                        },
                        label: {
                            paddingTop: 10,
                            paddingBottom: 10,
                            paddingLeft: 15,
                            paddingRight: 15
                        }
                    }, children: abbreviate && !isUpToMediumScreen
                        ? d.slice(0, 3)
                        : abbreviate && isUpToMediumScreen
                            ? d.slice(0, 1)
                            : titleCase(d) }, d));
            }) }) }));
};
